import styled from 'styled-components';
import { Select } from 'components';
import { colors } from 'styles/colors';

export const Card = styled.div`
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.24), 0 3px 12px rgba(0, 0, 0, 0.12);
`;

export const IrTableContainer = styled.table`
  width: 100%;
  box-shadow: rgba(62, 71, 86, 0.2) 0 2px 8px;
  border-collapse: collapse;
`;

export const IrTableHead = styled.thead``;

export const IrTableBody = styled.tbody`
  border: 1px solid ${colors.Grey};
`;

export const IrHeaderCell = styled.th`
  text-align: left;
  padding: 0 10px;
  border-bottom: solid 1px ${colors.Grey};
  font-size: 0.75rem;
  white-space: nowrap;
  background-color: ${colors.Blue300};
  color: ${colors.White};
  height: 40px;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

export const IrDataCell = styled.td`
  text-align: left;
  color: ${colors.DarkGrey};
  min-width: 50px;
  padding: 0 10px;
  font-size: 0.71rem;
`;

export const IrRow = styled.tr`
  height: 35px;
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.Grey};
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const SelectContainer = styled.div`
  font-weight: bold;
  position: fixed;
  z-index: 1050;
  background: white;
  border: 2px solid #d3d3d3;
  border-radius: 10px;
  box-shadow: 5px 6px 11px rgba(0,0,0,0.24), 0 14px 15px rgba(0,0,0,0.12);
`;

export const CustomSelect = styled(Select)`
  background-color: white;
  margin-bottom: 0;
`;

export const TextLine = styled.div`
  display: flex;
  align-items: center;
  color: #5d5d5d;
  margin-top: 10px;
`;

const BaseBadge = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
  white-space: nowrap;
`;

export const TempBadge = styled(BaseBadge)`
  background-color: #e8f4fd;
  color: #1a73e8;
  border: 1px solid #1a73e8;
`;

export const FanBadge = styled(BaseBadge)`
  background-color: #e6f9f4;
  color: #0b8a63;
  border: 1px solid #0b8a63;
`;

export const OffBadge = styled(BaseBadge)`
  background-color: #fdecea;
  color: #d32f2f;
  border: 1px solid #d32f2f;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  flex-direction: column;
`;
